export default __webpack_public_path__ + "static/media/basket.acd523c6.svg";